<template>
	<accountLayout :title="$t('account.activateTitle')" current="account" ref="layout">
		<div v-if="loading" class="account-state">{{ $t('account.activating') }}</div>
		<div v-else class="account-state-result">
			<p v-if="success" class="ok">{{ $t('account.activateSuccess') }}</p>
			<p v-else class="err">{{ msg }}</p>
			<div class="account-links" style="margin-top:24px;">
				<router-link :to="langPrefix + '/login'">{{ $t('account.goLogin') }}</router-link>
			</div>
		</div>
	</accountLayout>
</template>

<script>
import accountLayout from "@/components/c/accountLayout.vue"
import { verifyEmailApi } from "@/api/login.js"
export default {
	components: { accountLayout },
	data() { return { loading: true, success: false, msg: '' } },
	computed: {
		langPrefix() { const l = localStorage.getItem('i18n-lang') || 'zh'; return l == 'zh' ? '/cn' : '/en' }
	},
	created() {
		const token = this.$route.query.token
		if (!token) { this.loading = false; this.msg = this.$t('account.invalidLink'); return }
		verifyEmailApi({ token: token }).then(() => {
			this.success = true
			this.loading = false
		}).catch(err => {
			this.msg = (err && err.msg) ? err.msg : this.$t('account.activateFail')
			this.loading = false
		})
	}
}
</script>

<style scoped lang="scss">
.account-state {
	text-align: center;
	font-size: 15px;
	color: #666666;
}

.account-state-result {
	text-align: center;

	p {
		margin: 0;
		font-size: 15px;
		line-height: 1.6;
	}

	.ok {
		color: #000000;
	}

	.err {
		color: #c45656;
	}
}

.account-links {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 8px;
	font-size: 14px;

	span {
		color: #999999;
	}

	a {
		color: #000000;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}
}
</style>
